import { Button, Modal } from 'antd';
import React, { useState } from 'react';

const ConfirmationModalLoanType = ({ open, close,updateHandler }) => {
    return (
        <Modal open={open}
            centered
            onCancel={close}

            footer={[
                <Button key="submit" onClick={()=>{
                    updateHandler(true);
                    close();
                }} type="primary">
                    Yes
                </Button>,
                <Button key="back" onClick={()=>{
                    updateHandler(false);
                    close();
                }}>
                    No
                </Button>,
            ]} title="Confirmation">
            <p>Do You Want to Keep the exisiting Form Datas?</p>
        </Modal>
    );
};

export default ConfirmationModalLoanType;